import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import OrganizationAppResource from "./OrganizationAppResource";
import OrganizationMemberAppResource from "./OrganizationMemberAppResource";

export const ROLES = {
    OWNER: 'owner',
    ADMIN: 'administrator',
    AFFILIATE: 'affiliate',
};

class OrganizationRoleAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Organization-Role';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'organizations/roles';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'created_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'name',
            'slug',
            'description',
            'isSystem',
            'organization',
            'members',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            organization: OrganizationAppResource,
            members: OrganizationMemberAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            organization: 'organization_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            name: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            slug: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                }
            },
            isSystem: {
                type: 'boolean',
                presence: true,
            },
            organizationUuid: {
                type: 'string',
                presence: true,
            },
        };
    }

}

export default OrganizationRoleAppResource;
